module.exports = __webpack_public_path__ + "static/fonts/Arita-buriB.ba4e824.ttf";